"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFileTypeClient = void 0;
const browser_1 = require("file-type/browser");
const image_uploading_common_1 = require("./image_uploading_common");
const isValidFileTypeClient = (file) => __awaiter(void 0, void 0, void 0, function* () {
    if (!file) {
        return false;
    }
    // fileCheck is undefined if the file type is not recognised
    const fileCheck = yield (0, browser_1.fromBlob)(file);
    return !!fileCheck && (0, image_uploading_common_1.isAllowedMimeType)(fileCheck.mime.toString());
});
exports.isValidFileTypeClient = isValidFileTypeClient;
